import { useParams, Link } from "react-router-dom";
import { getArticlesByCategory, getCategoryBySlug, categories } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import SchemaOrg from "@/components/base/SchemaOrg";
import NotFound from "@/pages/NotFound";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || "");
  const categoryArticles = getArticlesByCategory(slug || "");

  if (!category) {
    return <NotFound />;
  }

  const breadcrumbItems = [
    { name: "首页", url: "http://biomicskin.cn/" },
    { name: category.name, url: `http://biomicskin.cn/category/${category.slug}` },
  ];

  return (
    <>
      <SchemaOrg
        type="WebPage"
        title={`${category.name} - 吃瓜网51`}
        description={category.description}
      />
      <SchemaOrg
        type="BreadcrumbList"
        breadcrumbs={breadcrumbItems}
      />

      {/* Category Header */}
      <section className="relative w-full py-16 md:py-20 bg-background-950 overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img
            src={category.image}
            alt={category.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70" />
        <div className="relative z-10 w-full px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-xs font-medium mb-4">
              分类导航
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-background-50 mb-3">
              {category.name}
            </h1>
            <p className="text-base md:text-lg text-background-300 max-w-xl leading-relaxed">
              {category.description}
            </p>
            <div className="flex items-center gap-4 mt-5 text-sm text-background-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-article-line w-4 h-4 flex items-center justify-center" />
                {category.articleCount}篇爆料
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
                持续更新中
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Other Categories Quick Nav */}
      <section className="w-full px-4 md:px-8 py-5 bg-background-100 border-b border-background-200/70">
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
          <span className="shrink-0 text-xs font-medium text-foreground-500 mr-2">
            其他分类:
          </span>
          {categories
            .filter((c) => c.slug !== slug)
            .map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="shrink-0 px-3 py-1.5 rounded-full text-xs font-medium bg-background-50 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors border border-background-200/70"
              >
                {cat.name}
              </Link>
            ))}
        </div>
      </section>

      {/* Articles Grid */}
      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
            {category.name}列表
          </h2>
          <span className="text-sm text-foreground-500">
            共 {categoryArticles.length} 篇
          </span>
        </div>

        {categoryArticles.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {categoryArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <i className="ri-article-line w-12 h-12 flex items-center justify-center text-4xl text-foreground-300 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-foreground-700 mb-2">
              暂无内容
            </h3>
            <p className="text-sm text-foreground-500">
              该分类下暂时没有爆料内容，去看看其他分类吧
            </p>
          </div>
        )}
      </section>
    </>
  );
}